import React from 'react';
import PatientsTable from './PatientsTable';
import PatientsGrid from './PatientsGrid';
import './PatientsView.css';

const PatientsView = ({ 
  patients, 
  onView,
  onRestore,
  formatDate,
  readOnly = false,
}) => {
  return (
    <div className="patients-view">
      {/* Grid view - visible on mobile */}
      <div className="mobile-only">
        <PatientsGrid
          patients={patients}
          onView={onView}
          onRestore={onRestore}
          formatDate={formatDate}
          readOnly={readOnly}
        />
      </div>
      
      {/* Table view - visible on desktop */}
      <div className="desktop-only">
        <PatientsTable
          patients={patients}
          onView={onView}
          onRestore={onRestore}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
};

export default PatientsView; 